//
//
//
//
//
//

export default {
    name: 'sprite-icon',
    props: {
        icon: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            required: false,
            default: 32,
        },
        height: {
            type: Number,
            required: false,
            default: 32,
        },
    },
};
